/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-department.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@ngx-translate/core/src/translate.pipe';
import * as i4 from '@ngx-translate/core/src/translate.service';
import * as i5 from '../../../../../../../app/modules/employee/pages/departments/select-department/select-department.component';
import * as i6 from '@angular/common';
import * as i7 from '../../../../../../../app/modules/employee/service/department/department.service';
const styles_SelectDepartmentComponent:any[] = [i0.styles];
export const RenderType_SelectDepartmentComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectDepartmentComponent,data:{}});
function View_SelectDepartmentComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,
          [8,(null as any)]],{value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),
          0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],{value:[0,'value']},
          (null as any)),(_l()(),i1.ɵted(3,(null as any),['',''])),i1.ɵpid(131072,
          i3.TranslatePipe,[i4.TranslateService,i1.ChangeDetectorRef])],(_ck,_v) => {
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.selected;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform(_v.context.$implicit.name));
    _ck(_v,3,0,currVal_3);
  });
}
export function View_SelectDepartmentComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['input',
      1]],(null as any),4,'select',[['class','form-control']],[[8,'disabled',0]],[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i5.SelectDepartmentComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.change($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectDepartmentComponent_1)),
      i1.ɵdid(4,802816,(null as any),0,i6.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i5.SelectDepartmentComponent = _v.component;
    const currVal_1:any = _co.departmentsOptions;
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.SelectDepartmentComponent = _v.component;
    const currVal_0:any = _co.disabled;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_SelectDepartmentComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-select-department',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectDepartmentComponent_0,
      RenderType_SelectDepartmentComponent)),i1.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i5.SelectDepartmentComponent]),i1.ɵdid(2,638976,(null as any),0,i5.SelectDepartmentComponent,
      [i1.Renderer2,i7.DepartmentService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const SelectDepartmentComponentNgFactory:i1.ComponentFactory<i5.SelectDepartmentComponent> = i1.ɵccf('app-select-department',
    i5.SelectDepartmentComponent,View_SelectDepartmentComponent_Host_0,{departmentId:'departmentId',
        departmentPosition:'departmentPosition',disabled:'disabled',venue_id:'venue_id',
        deleteInnovationOptions:'deleteInnovationOptions'},{onMyChange:'onMyChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZGVwYXJ0bWVudHMvc2VsZWN0LWRlcGFydG1lbnQvc2VsZWN0LWRlcGFydG1lbnQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2RlcGFydG1lbnRzL3NlbGVjdC1kZXBhcnRtZW50L3NlbGVjdC1kZXBhcnRtZW50LmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2RlcGFydG1lbnRzL3NlbGVjdC1kZXBhcnRtZW50L3NlbGVjdC1kZXBhcnRtZW50LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZGVwYXJ0bWVudHMvc2VsZWN0LWRlcGFydG1lbnQvc2VsZWN0LWRlcGFydG1lbnQuY29tcG9uZW50LnRzLlNlbGVjdERlcGFydG1lbnRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VsZWN0ICNpbnB1dCAoY2hhbmdlKT1cImNoYW5nZSgkZXZlbnQpXCIgY2xhc3M9XCJmb3JtLWNvbnRyb2xcIiBbZGlzYWJsZWRdPVwiZGlzYWJsZWRcIj5cclxuICAgIDxvcHRpb24gdmFsdWU9XCJ7e2RlcGFydG1lbnQuaWR9fVwiICpuZ0Zvcj1cImxldCBkZXBhcnRtZW50IG9mIGRlcGFydG1lbnRzT3B0aW9uc1wiIFtzZWxlY3RlZF09XCJkZXBhcnRtZW50LnNlbGVjdGVkXCI+e3tkZXBhcnRtZW50Lm5hbWUgfCB0cmFuc2xhdGV9fTwvb3B0aW9uPlxyXG48L3NlbGVjdD5cclxuIiwiPGFwcC1zZWxlY3QtZGVwYXJ0bWVudD48L2FwcC1zZWxlY3QtZGVwYXJ0bWVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNDSTtNQUFBO2FBQUE7VUFBQSw2REFBQTtVQUFBO1VBQUEsZUFBaUg7MkJBQUE7SUFBekc7SUFBUixXQUFRLFNBQVI7SUFBUTtJQUFSLFdBQVEsU0FBUjs7SUFBZ0Y7SUFBaEYsV0FBZ0YsU0FBaEY7SUFBaUg7SUFBQTs7OztzREFEckg7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFlO01BQUE7TUFBQTtJQUFBO0lBQWY7RUFBQSxnQ0FBb0YsOENBQ2hGO2FBQUE7YUFBQTs0QkFBQSx5Q0FBeUo7VUFBQSx1QkFDcEo7O0lBRDZCO0lBQWxDLFdBQWtDLFNBQWxDOzs7SUFEMEQ7SUFBOUQsV0FBOEQsU0FBOUQ7Ozs7b0JDQUE7TUFBQTswQ0FBQTtNQUFBO1FBQUE7TUFBQSx5Q0FBQTtNQUFBO0lBQUE7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/departments/select-department/select-department.component.ngfactory.ts